import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIG, AppConfig } from 'tekkeys-common';

// -------------------- Color --------------------
export interface ColorItemModel {
  id?: number;
  name: string;
  variable: string;
  value: string;
  description?: string;
  previewType?: 'button' | 'icon' | 'background' | 'text';
}

// -------------------- Payment Icon --------------------
export interface PaymentIconModel {
  id?: number;
  iconUrl: string;
  name?: string;
  orderIndex?: number;
  enabled?: boolean; // add enabled to match backend DTO
}

// -------------------- Ads --------------------
export type AdType = 'left' | 'right' | 'center' | 'center-small' | 'carousel';

export interface AdItemModel {
  id?: number;
  type: AdType;
  pictureUrl: string | null;
  safeUrl?: any;
  link: string;
  sponsor?:string;
  orderIndex?: number;
  forceShow?: boolean;
  visible?: boolean;
}

// -------------------- Parameter --------------------
export interface ParameterModel {
  id?: number;
  // Global parameters
  companyName: string;
  description?: string;
  paiementDescription?: string;
  logoUrl?: string;
  faviconUrl?: string;
  websiteName?: string;
  address?: string;
  phoneNumber?: string;
  supportEmail?: string;
  commercialName?: string;
  openingTime?: string;
  closingTime?: string;
  htmlMapEmbedCode?: string;
  mapsSharedLink?: string;

  // Related entities
  colors?: ColorItemModel[];
  sections?: Section[];
  paymentIcons?: PaymentIconModel[];
  ads?: AdItemModel[];

  // Important metadata
  lastUpdated?: Date;
}

// -------------------- Section hierarchy --------------------
export type SubSectionType = 'text' | 'image';
export type ButtonType = 'primary' | 'secondary' | 'tertiary';

export interface Button {
  id: number;
  type: ButtonType;
  label: string;
  orderIndex: number;
}

export interface SubSection {
  id: number;
  type: SubSectionType;
  title?: string;
  content?: string;
  imageUrl?: string;
  orderIndex: number;
  heightSpan: number;
  widthSpan: number;
  buttons?: Button[]; // optional
}

export interface Row {  // renamed from Row to avoid POI conflict
  id: number;
  subSections?: SubSection[];
  orderIndex: number;
}

export interface Section {  // renamed from SectionContentModel / Section
  id?: number;
  title: string;
  groupName: string;
  rows?: Row[];
  orderIndex: number;
}

@Injectable({
  providedIn: 'root',
})
export class ParameterService {
  private baseUrl: string;

  constructor(
    private http: HttpClient,
    @Inject(APP_CONFIG) private appConfig: AppConfig
  ) {
    this.baseUrl = `${this.appConfig.apiEndpoint}/parameter`; // adjust endpoint
  }

  /** Fetch the global parameter from backend */
  getParameter(): Observable<ParameterModel> {
    return this.http.get<ParameterModel>(`${this.baseUrl}`);
  }


  /** Get last updated date */
  getLastUpdated(): Observable<string> {
    return this.http.get<string>(`${this.baseUrl}/last-updated`);
  }

}
